import { useState } from "react";
import {
    Box,
    Button,
    Grid2,
    Typography,
    Paper,
    Divider,
    useMediaQuery,
    InputBase} from "@mui/material"
import Styles from "./Web.module.css"
import validator from "validator";
import axios from "axios"
import pic from "../../../../ui-utils/latestPics/derivativesTalk.svg"
import { backendHosts } from "../../../../ui-utils/apiConfig"
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useLanguage } from "../../../../Context/LangContext";
import en from "../../../../i18n/English/Trade Invest/talk.json";
import hi from "../../../../i18n/Hindi/Trade Invest/talk.json";
import kn from "../../../../i18n/Kannada/Trade Invest/talk.json";
import ma from "../../../../i18n/Marathi/Trade Invest/talk.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/talk.json";
export default function DerivativesTalkWeb(){
     const [mobileNo, setMobileNo] = useState("");
      const clientErr = {};
      const [mobClientErr, setMobileClientErr] = useState({});

    const { language } = useLanguage();
    const translations = { en, hi, kn,gu,ma };
    const t = translations[language];

    const isSmallScreen = useMediaQuery("(max-width:1000px)");

      const handleMobilenoEnter = async() => {
        const runValidation = () => {
          if (mobileNo.trim().length == 0) {
            clientErr.mobileNo = "Please Enter your mobile number";
            return;
          }
          if (!validator.isMobilePhone(mobileNo, "en-IN")) {
            console.log("false")
            clientErr.mobileNo = "Please Enter Valid mobile number";
            return;
          }
        };
        runValidation();
        if (Object.keys(clientErr).length == 0) {
            const payload={
                data:{
                    mobile:mobileNo
                }
            }

            const response = await axios.post(`${backendHosts.ADMIN}/api/public/fno_specialist`,payload);
            console.log("result",response.data.data)
            if(response.data.data.status == 200){
                setMobileNo("")
                clientErr.successMessage ="Thank you for reaching out!. One of our representatives will contact you shortly."
                clientErr.mobileNo=""
                setMobileClientErr(clientErr);
            }else{
               clientErr.mobileNo=response.data.data.data.message
                clientErr.successMessage=""
                setMobileClientErr(clientErr)
            }



        } else {
          setMobileClientErr(clientErr);
        }
      };

      const handleMobileNoChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 10);

        setMobileNo(limitedValue);
      };
    return(
    <>
        <Grid2 className={Styles.outerCard}>
                <AnimationOnScroll animateIn="animate__fadeInLeft"
                    animateOnce={true}
                    className={Styles.customFadeInLeft}>
            <img src={pic} alt="Derivative Talk" className={Styles.pic} />
            </AnimationOnScroll>
                <AnimationOnScroll animateIn="animate__fadeInRight"
                    animateOnce={true}
                    className={Styles.customFadeInLeft}>
            <Grid2 className={Styles.innerCard}>

                        <div className={Styles.headingContainer}>
                            <div className={Styles.gradientBackground}></div>
                            <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                                {t.title}
                            </Typography>
                        </div>
                    <h7 className={Styles.subtitle}>
                    {t.subtitle}
                </h7>


                {
                        isSmallScreen ? <>
                            <Grid2 className={Styles.fieldCard}>

                                <Paper component="form" className={Styles.smallmobilefield}>
                                    <Typography className={Styles.smallpreMobile}>91</Typography>
                                    <Divider className={Styles.divider} orientation="vertical" />
                                    <InputBase
                                        className={Styles.smallinputbase}
                                            placeholder={t.formFields.mobilePlaceholder}
                                        onChange={handleMobileNoChange}
                                        value={mobileNo}
                                    />
                                </Paper>

                                {mobClientErr.mobileNo ? (
                                    <Typography className={Styles.errMsgg}>
                                        {mobClientErr.mobileNo}
                                    </Typography>
                                ) : (
                                    mobClientErr.successMessage && (
                                        <Typography className={Styles.successMsg}>
                                            {mobClientErr.successMessage}
                                        </Typography>
                                    )
                                )}
                                <Button
                                    variant="contained"
                                    onClick={handleMobilenoEnter}
                                    className={Styles.smalldematButton}
                                >
                                        {t.formFields.buttonText}
                                </Button>
                            </Grid2></> :
                        <>
                        <Paper component="form" className={Styles.mobilefield}>
                            <Typography className={Styles.preMobile}>91</Typography>

                            <InputBase
                                className={Styles.inputbase}
                                placeholder={t.formFields.mobilePlaceholder}
                                value={mobileNo}
                                onChange={handleMobileNoChange}
                            />
                            <Button className={Styles.dematButton} onClick={handleMobilenoEnter}>
                             {t.formFields.buttonText}
                            </Button>

                        </Paper>
                                {mobClientErr.mobileNo ? (
                                    <Typography className={Styles.errMsgg}>
                                        {mobClientErr.mobileNo}
                                    </Typography>
                                ) : (
                                    mobClientErr.successMessage && (
                                        <Typography className={Styles.successMsg}>
                                                {mobClientErr.successMessage}
                                        </Typography>
                                    )
                                )}
                        </>
                }

            </Grid2>
            </AnimationOnScroll>
        </Grid2>
    </>
    )
}